import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const absoluteUrl = (path) => {
  if (!path) return null;
  return path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
};

export const api = axios.create({ baseURL: API, withCredentials: true });
